import React, {FunctionComponent, ReactElement} from 'react';
import {Container} from '@inlet/react-pixi';
import {UpdateManager} from '@gongxigames/framework/core';
import {useAnimationShow} from '@gongxigames/framework/core/fragments/react';

export type SlideViewProps = {
    updateManager: UpdateManager;
    slide: ReactElement;
    visible: boolean;
};

export const SlideView: FunctionComponent<SlideViewProps> = (props) => {
    const {slide, updateManager, visible} = props;
    const [alpha] = useAnimationShow(visible, updateManager, 200);

    return (
        <Container
            position={[0, -868]}
            name='SlideView'
            visible={visible}
            alpha={alpha}
        >{slide}</Container>
    );
};
